import { PropertyMap, UserAction, userActionTypeEnum } from '@thoughtspot/metrics';

export type ChecklistCollectEvent = (
    userAction: UserAction,
    property: PropertyMap,
) => void;

export interface ChecklistBaseProperties {
    selectedFunction: string;
    selectedIndustry: string;
    sectionOpened: string;
    taskOpened: string;
    loadType: string;
    taskCompletedBU: number;
    taskCompletedAU: number;
    taskCompletedDU: number;
    [key: string]: any;
}

export type ChecklistOpenedProperties = ChecklistBaseProperties;

export interface ChecklistClosedProperties extends ChecklistBaseProperties {
    sectionSelected: string;
    taskSelected: string;
}

export interface ChecklistSectionSelectedProperties
    extends ChecklistBaseProperties {
    sectionSelected: string;
}

export interface ChecklistTaskSelectedProperties
    extends ChecklistBaseProperties {
    sectionSelected: string;
    taskSelected: string;
}

export interface ChecklistErrorProperties extends ChecklistClosedProperties {
    errorType: string;
}

export const checklistOpened = (
    collectEvent: ChecklistCollectEvent,
    properties: ChecklistOpenedProperties,
) => {
    collectEvent(
        new UserAction(userActionTypeEnum.CHECKLIST_OPENED),
        properties,
    );
};

export const checklistClosed = (
    collectEvent: ChecklistCollectEvent,
    properties: ChecklistClosedProperties,
) => {
    collectEvent(
        new UserAction(userActionTypeEnum.CHECKLIST_CLOSED),
        properties,
    );
};

export const checklistSectionSelected = (
    collectEvent: ChecklistCollectEvent,
    properties: ChecklistSectionSelectedProperties,
) => {
    collectEvent(
        new UserAction(userActionTypeEnum.CHECKLIST_SECTION_SELECTED),
        properties,
    );
};

export const checklistTaskSelected = (
    collectEvent: ChecklistCollectEvent,
    properties: ChecklistTaskSelectedProperties,
) => {
    collectEvent(
        new UserAction(userActionTypeEnum.CHECKLIST_TASK_SELECTED),
        properties,
    );
};

export const checklistTaskCtaClicked = (
    collectEvent: ChecklistCollectEvent,
    properties: ChecklistTaskSelectedProperties,
) => {
    collectEvent(
        new UserAction(userActionTypeEnum.CHECKLIST_TASK_CTA_CLICKED),
        properties,
    );
};

export const checklistTaskCompleted = (
    collectEvent: ChecklistCollectEvent,
    properties: ChecklistTaskSelectedProperties,
) => {
    collectEvent(
        new UserAction(userActionTypeEnum.CHECKLIST_TASK_COMPLETED),
        properties,
    );
};

export const checklistErrorShown = (
    collectEvent: ChecklistCollectEvent,
    properties: ChecklistErrorProperties,
) => {
    collectEvent(
        new UserAction(userActionTypeEnum.CHECKLIST_ERROR_SHOWN),
        properties,
    );
};
